import { adaptFormDataFunction } from '../types';

const adaptFormData: adaptFormDataFunction = (data, field) => ({
  startTime: data?.value ? new Date(data.value) : null,
});

export default adaptFormData;
